module.exports = __webpack_public_path__ + "img/ltkparties-1x.122e500.jpg";